import React from "react";

const AccountSettingsPanel: React.FC = () => {
  return (
    <div className="profile-settings">
      <section className="profile-section">
        <h2 className="profile-section-title">Notifications</h2>
        <div className="form-group checkbox-group">
          <label>
            <input type="checkbox" checked disabled readOnly />
            Email notifications (on)
          </label>
        </div>
        <p className="form-hint">More notification preferences coming soon.</p>
      </section>
    </div>
  );
};

export default AccountSettingsPanel;
